import { PhotoReel } from 'features/kestrelViewer/ui/tools/photoreel'
import { ViewControlsSubmenu } from 'features/kestrelViewer/ui/tools/viewControls/ViewControlsSubmenu'
import React from 'react'

export const ViewToggles: React.FC = () => {
  return (
    <div>
      <ViewControlsSubmenu />
      <PhotoReel />
    </div>
  )
}
